import { H1, H2, H3, H4, H5, H6 } from '@fs/zion-ui'

export const zionHeadingMap = {
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  h6: H6,
}

const cascadeHeadingMap = {
  h1: 'h2',
  h2: 'h3',
  h3: 'h4',
  h4: 'h5',
  h5: 'h6',
  h6: 'div',
}

export default function useHeadingLevel(headingLevel = 'h1') {
  const Heading = zionHeadingMap[headingLevel]
  const currentHeadingLevel = headingLevel

  return { Heading, currentHeadingLevel, nextHeadingLevel: cascadeHeadingMap[currentHeadingLevel] }
}
